<template>
  <div class="main">
    <el-form :inline="true">
      <el-form-item label="学校名称：">
        <el-input v-model="query.school_name" placeholder="请输入学校名称"></el-input>
      </el-form-item>
      <el-form-item label="投递状态：">
        <el-select v-model="query.apply_status">
          <el-option label="全部" value></el-option>
          <el-option label="已录用" value="enterprise_passed"></el-option>
          <el-option label="不合适" value="enterprise_refused"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getResumes">搜索</el-button>
      </el-form-item>
    </el-form>
    <ul class="resume">
      <li v-for="item in resumes" :key="item.apply_id">
        <div class="left-content">
          <img src="../../../assets/img/resume/profile-photo.png" alt />
          <div class="base-info">
            <div class="line-1">
              <strong>{{item.student_name}}</strong>
              <span>{{item.job_name}}</span>
            </div>
            <div class="line-2">
              <span>{{item.created_at}}</span>
              <span>{{item.school_name}}</span>
              <span>{{item.major}}</span>
              <span>{{item.fdGraduationYear}}届</span>
              <span>{{item.phone}}</span>
              <!-- <span>简历状态：{{item.applyStatus}}</span> -->
            </div>
          </div>
        </div>
        <div class="right-content">
          <span>{{item.created_at}}</span>
          <div class="handle-btn" v-if="pending.indexOf(item.apply_status) > 0">
            <span class="edit-btn" @click="edit(item.apply_id, 'enterprise_passed')">录用</span>
            <span class="edit-btn" @click="edit(item.apply_id, 'enterprise_refused')">不合适</span>
          </div>
          <div v-else>{{item.applyStatus}}</div>
        </div>
      </li>
    </ul>
    <div v-if="total == 0" class="noData">暂无简历投递！</div>
    <Pagination
      ref="pagination"
      :total="total"
      @size-change="getResumes"
      @current-change="getResumes"
    />
  </div>
</template>

<script>
import Pagination from "@/components/pagination"; // 分页组件
import formatter from "@/assets/js/mixins/formatter"; // 公用函数

export default {
  components: {
    Pagination
  },
  mixins: [formatter],
  data() {
    return {
      query: {
        // 查询条件
        apply_status: "", // 投递状态
        school_name: "" // 学校名称
      },
      resumes: [], // 简历
      total: 0,
      pending: ["student", "school_passed", "school_refused"] // 待处理状态
    };
  },
  mounted() {
    this.getResumes();
  },
  methods: {
    async getResumes() {
      let params = this.delNullVal(this.query);
      params.page = this.$refs.pagination.page;
      params.page_size = this.$refs.pagination.page_size;
      let res = await this.$api.studentManage.getStudentApplyList(params);
      if (res.code === 0) {
        this.resumes = res.data.items.map(item => {
          item.applyStatus = this.formatApplyStatus(item.apply_status);
          return item;
        });
        this.total = res.data.count;
      }
    },
    async edit(operateId, apply_status) {
      let params = {
        apply_status
      };
      let res = await this.$api.job.updateDeliver(operateId, params);
      if (res.code === 0) {
        this.$message.success("成功！");
        this.getResumes();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  .resume {
    margin-top: 24px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 1px 16px 0px #d2d2d2;
      border-radius: 24px;
      padding: 24px 16px;
      color: #929292;
      margin-bottom: 20px;
      .left-content {
        display: flex;
        align-items: center;
        img {
          width: 57px;
          height: 57px;
        }
        .base-info {
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          color: #929292;
          .line-1 {
            strong {
              color: #000;
              margin-right: 20px;
            }
          }
          .line-2 {
            span:not(:last-child) {
              &::after {
                content: "";
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #929292;
                margin: 0 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .right-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 57px;
        position: relative;
        .edit-btn {
          display: inline-block;
          width: 73px;
          height: 31px;
          margin-right: 10px;
          text-align: center;
          line-height: 31px;
          background: rgba(59, 163, 240, 1);
          border-radius: 9px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
  .noData {
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
}
</style>